import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

const STICKY_NAV_QUERY = '(min-width: 960px)';
const SCROLL_PADDING = 24;

function getStickyNavOffset(target) {
  const header = document.getElementById('header');
  if (!header || !window.matchMedia(STICKY_NAV_QUERY).matches) {
    return SCROLL_PADDING;
  }

  const headerHeight = header.offsetHeight;
  const targetTop = target.getBoundingClientRect().top;
  const willScrollUp = targetTop < 0;
  const hiddenByStickyNav =
    document.body.classList.contains('scrolling-up') &&
    targetTop < headerHeight + SCROLL_PADDING;

  if (willScrollUp || hiddenByStickyNav) {
    return headerHeight + SCROLL_PADDING;
  }

  return SCROLL_PADDING;
}

export function scrollToTarget(target) {
  const top = target.getBoundingClientRect().top + window.scrollY - getStickyNavOffset(target);
  window.scrollTo(0, Math.max(0, top));
}

function handleLink(link) {
  const href = link.getAttribute('href');
  const target = document.querySelector(href);
  if (!target) return;
  
  gsap.to(window, {
    duration: 0.5,
    scrollTo: target,
  })
}

function handleFootnoteClick(e) {
  const link = e.target.closest('sup.footnote a[href^="#"], a.matrix-footnotes__back[href^="#"]');
  if (!link) {
    return;
  }

  const id = decodeURIComponent(link.getAttribute('href').slice(1));
  const target = document.getElementById(id);
  if (!target) {
    return;
  }

  e.preventDefault();
  e.stopImmediatePropagation();
  scrollToTarget(target);
  history.pushState(null, '', link.getAttribute('href'));
}

export default function() {
  document.addEventListener('click', handleFootnoteClick, true);

  document.addEventListener('click', function(e) {
    const link = e.target.closest('.js-home-anchor');
    if (link) {
      e.preventDefault();
      handleLink(link);
    }
  });
}
